import React, { useContext, useRef, useState } from 'react'
import { FiSearch } from 'react-icons/all'
import Context from '../../context'

function ClippingPartnersModal() {
  const searchButton = useRef(null)
  const { selectedPartnerList, setSelectedPartnerList, fullPartnerList } = useContext(Context)
  const [partnerListToSelect, setPartnerListToSelect] = useState([])
  const [searchValue, setSearchValue] = useState('')

  const handleSearchButton = () => {
    if (searchValue.length > 0) {
      const newArr = fullPartnerList.filter(item => {
        return item.fantasyName.toLowerCase().includes(searchValue.toLowerCase())
      })
      setPartnerListToSelect([...newArr])
    } else {
      setPartnerListToSelect([])
    }
  }

  const handleSelectItem = id => {
    const newArr = partnerListToSelect.filter(item => id === item.id)
    setSelectedPartnerList(selectedPartnerList => [...newArr, ...selectedPartnerList])

    const newSelectedArr = partnerListToSelect.filter(item => id !== item.id)
    setPartnerListToSelect([...newSelectedArr])
  }

  const handleRemoveItem = id => {
    const newArr = selectedPartnerList.filter(item => id === item.id)

    setPartnerListToSelect(selectedPartnerList => [...selectedPartnerList, ...newArr])

    const newArrSelected = selectedPartnerList.filter(item => id !== item.id)
    setSelectedPartnerList([...newArrSelected])
  }

  return (
    <div
      className="modal fade"
      id="clippingPartnersModal"
      tabIndex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div className="modal-dialog" style={{ top: '200px' }} role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Selecione os Parceiros:</h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-12">
                <div className="input-group clube-clipping-inputs">
                  <input
                    onChange={e => setSearchValue(e.target.value)}
                    value={searchValue}
                    type="text"
                    className="form-control clube-border"
                    placeholder="Buscar"
                    onKeyPress={e => e.key === 'Enter' && searchButton.current.click()}
                  />
                  <div className="input-group-prepend">
                    <button
                      ref={searchButton}
                      type="button"
                      className="input-group-text"
                      onClick={handleSearchButton}
                    >
                      <FiSearch />
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">Parceiro</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedPartnerList.map(item => (
                      <tr key={item.id} className="table-success">
                        <td>
                          <div
                            className="item-click"
                            onKeyPress={() => {}}
                            role="button"
                            tabIndex={0}
                            onClick={() => handleRemoveItem(item.id)}
                          >
                            {item.fantasyName}
                          </div>
                        </td>
                      </tr>
                    ))}

                    {partnerListToSelect.map(item => (
                      <tr key={item.id}>
                        <td>
                          <div
                            className="item-click"
                            onKeyPress={() => {}}
                            role="button"
                            tabIndex={0}
                            onClick={() => handleSelectItem(item.id)}
                          >
                            {item.fantasyName}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button data-dismiss="modal" type="button" className="btn clube-btn clube-blue">
              Confirmar
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ClippingPartnersModal
